'use strict'

/**
 *
 * @name: nnSocialList
 *
 */

import DirectiveTemplate from './nn-social-list.directive.html'
import './nn-social-list.directive.scss'

function NnSocialListDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    scope: {
      analyticsSection: '=*',
      showSubscribeBtn: '=*',
      theme: '=*' // :string, :array<string>
    },
    template: DirectiveTemplate,
    controller: nnSocialListDirectiveController
  }
}

function nnSocialListDirectiveController ($scope) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */
  $scope.className = () => {
    if (Array.isArray($scope.theme)) {
      let cls = ''
      $scope.theme.forEach(theme => {
        cls += `nn-social-list--${theme} `
      })
      return cls
    } else {
      return `nn-social-list--${$scope.theme}`
    }
  }



  /*
   *
   * @PUBLIC
   *
   */


  /*
   *
   * @PRIVATE
   *
   */



  /*
   *
   * @INIT
   *
   */



}

export default NnSocialListDirective



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-social-list/nn-social-list.directive.js